import ButtonLink from "@affinity/components/ButtonLink";
import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    isQtyAdjusted: boolean;
    multipleProducts: boolean;
}

type Props = OwnProps;

export interface ProductAddedToCartMessageStyles {
    messageWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    abstract?: TypographyPresentationProps;
    quantityAdjustedText?: TypographyPresentationProps;
    continueShoppingLinkCss?: InjectableCss;
}

export const productAddedToCartMessageStyles: ProductAddedToCartMessageStyles = {
    title: {
        variant: "h4",
        forwardAs: "p",
        size: styleHelpers.rem(16),
        lineHeight: 1.5,
        css: css`
            margin: 0 0 ${styleHelpers.rem(10)};
        `
    },
    abstract: {
        variant: "p",
        size: styleHelpers.rem(15),
        lineHeight: 1.67,
        css: css`
            margin: 0 0 ${styleHelpers.rem(10)};
        `
    },
    continueShoppingLinkCss: {
        css: css`
            margin: 0 0 ${styleHelpers.rem(20)};
            font-size: ${styleHelpers.rem(15)};
            line-height: 1.73;
            color: ${styleConstants.colours.darkBlue};
            text-decoration-line: underline;
            text-decoration-skip-ink: none;
            text-decoration-thickness: ${styleHelpers.rem(2)};
            &&:hover{
                color: ${styleConstants.colours.errorRed};
                span{
                    color: ${styleConstants.colours.errorRed};
                }
            }
    `,}
};

const styles = productAddedToCartMessageStyles;

const ProductAddedToCartMessage = ({ isQtyAdjusted, multipleProducts }: Props) => {
    const defaultMessage = multipleProducts
        ? siteMessage("Cart_AllProductsAddedToCart")
        : siteMessage("Cart_ProductAddedToCart");
    const messageAbstract = siteMessage("Cart_ProductAddedToCartAbstract");
    const messageLinkCta = siteMessage("Cart_ProductAddedToCartLinkCta");
    const messageButtonCta = siteMessage("Cart_ProductAddedToCartButtonCta");

    return (
        <StyledWrapper {...styles.messageWrapper}>
            <Typography {...styles.title}>{defaultMessage}</Typography>
            <Typography {...styles.abstract}>{messageAbstract}</Typography>
            <Link aria-hidden href="http://localhost:3000/Catalog/1002-1" mergeCss {...styles.continueShoppingLinkCss}>{messageLinkCta}</Link>
            <ButtonLink aria-hidden href="/Cart" icon={{position: "right", src: ChevronRight}}>{messageButtonCta}</ButtonLink>
        </StyledWrapper>
    );
};

export default ProductAddedToCartMessage;
